import { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import "../../../styles/panel/user/ManageShops.css";
import { API_BASE_URL } from "../../../api/http";
import { fetchMyStores, fetchSupportStores } from "../../../api/storeRequest";
import moment from "jalali-moment";
import {
  Icon,
  ICONS,
  MY_SITES_PATH,
  ACTIONS,
  SEARCH_ICON,
  BACK_ICON,
  LINK_ICON,
  CALENDAR_ICON,
  CHEVRON_LEFT,
} from "./manageShop/shared/EditShopShared";

// این صفحه با کلیک روی یک فروشگاه در لیست (ManageShops.jsx) باز میشه
// مسیر پیشنهادی روت: manage-shops/:shopId  (فرزند همون روتی که ManageShops توشه)
export default function ManageShopDetail() {
  const navigate = useNavigate();
  const location = useLocation();
  const { shopId } = useParams();
  const role = localStorage.getItem("role");
  const isSupport = role === "support";
  const isUser = role === "user";

  // اگه از صفحه‌ی لیست با state اومده باشیم، فروشگاه رو مستقیم داریم
  // وگرنه (مثلاً بعد از رفرش صفحه) دوباره لیست رو می‌گیریم و پیداش می‌کنیم
  const [shop, setShop] = useState(location.state?.shop || null);
  const [loading, setLoading] = useState(!location.state?.shop);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    if (shop) return;

    let cancelled = false;
    (async () => {
      try {
        setLoading(true);
        const res =
          role == "user"
            ? await fetchMyStores()
            : role == "support"
              ? await fetchSupportStores()
              : { data: [] };
        const found = (res.data || []).find(
          (s) => String(s.store_id) === String(shopId),
        );
        if (cancelled) return;
        if (found) {
          setShop(found);
        } else {
          setNotFound(true);
        }
      } catch (err) {
        console.log(err);
        if (!cancelled) setNotFound(true);
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [shop, shopId, role]);

  const isActive = (s) => {
    if (!s?.end_date) return false;
    return moment(s.end_date).isSameOrAfter(moment());
  };

  const handleAction = (actionId) => {
    // مسیر نسبی: .../manage-shops/:shopId/:actionId
    navigate(`${actionId}`, { state: { shop } });
  };

  if (loading) {
    return (
      <div className="shop-manage">
        <div className="sm-empty">
          <p>در حال دریافت اطلاعات فروشگاه...</p>
        </div>
      </div>
    );
  }

  if (notFound || !shop) {
    return (
      <div className="shop-manage">
        <div className="sm-empty">
          <div className="sm-empty-ic">
            <Icon>{SEARCH_ICON}</Icon>
          </div>
          <h3>فروشگاه پیدا نشد</h3>
          <p>ممکنه آدرس اشتباه باشه یا فروشگاه حذف شده باشه.</p>
        </div>
        <div className="sm-detail-back-wrap">
          <button
            type="button"
            className="esp-back-btn"
            onClick={() => navigate(-1)}
          >
            <Icon>{BACK_ICON}</Icon>
          </button>
        </div>
      </div>
    );
  }

  const active = isActive(shop);

  // مشخصات پشتیبان فروشگاه (اسم فیلدها رو با خروجی بک‌اند هماهنگ کن)
  const supporterPhone = shop.assigned_mobile || null;
  const supporterName =
    [shop.assigned_to?.first_name, shop.assigned_to?.last_name]
      .filter(Boolean)
      .join(" ") || null;

  return (
    <div className="shop-manage">
      <div className="esi-head">
        <button
          type="button"
          className="esp-back-btn"
          onClick={() => navigate(-1)}
        >
          <Icon>{BACK_ICON}</Icon>
        </button>
        <div>
          <h1>ویرایش فروشگاه</h1>
          <p>مدیریت و ویرایش اطلاعات و ظاهر فروشگاه</p>
        </div>
      </div>
      <div className="sm-card sm-detail-card">
        <div className="sm-card-top">
          <div className="sm-identity">
            {shop.logo ? (
              <img
                className="sm-logo"
                src={`${API_BASE_URL}${shop.logo}`}
                alt={shop.store_name || "Shop logo"}
              />
            ) : (
              <div className="sm-logo sm-logo-placeholder">
                {shop.store_name?.slice(0, 2) || "ف"}
              </div>
            )}
            <div>
              <h2>{shop.store_name}</h2>
              <a
                className="sm-link"
                href={`/${shop.store_slug}`}
                target="_blank"
                rel="noreferrer"
              >
                <Icon>{LINK_ICON}</Icon>
                {shop.store_slug}
              </a>
            </div>
          </div>

          {isUser && (
            <div className="sm-supporter">
              <span className="sm-label">پشتیبان فروشگاه</span>
              {supporterName || supporterPhone ? (
                <div className="sm-supporter-div">
                  {supporterName && (
                    <div className="sm-supporter-row">
                      <span className="sm-supporter-key">نام</span>
                      <span className="sm-supporter-name">{supporterName}</span>
                    </div>
                  )}
                  {supporterPhone && (
                    <div className="sm-supporter-row">
                      <span className="sm-supporter-key">شماره تماس</span>
                      <a
                        className="sm-supporter-phone sm-mono"
                        href={`tel:${supporterPhone}`}
                        dir="ltr"
                      >
                        {supporterPhone}
                      </a>
                    </div>
                  )}
                </div>
              ) : (
                <span className="sm-supporter-empty">ثبت نشده</span>
              )}
            </div>
          )}
        </div>

        <div className="sm-meta">
          <div className="sm-meta-item sm-meta-item--full">
            <span className="sm-label">وضعیت اشتراک</span>
            <div
              className={`sm-sub-box ${
                active ? "sm-sub-box--active" : "sm-sub-box--expired"
              }`}
            >
              <div className="sm-sub-info">
                <span className="sm-sub-icon">
                  <Icon>{CALENDAR_ICON}</Icon>
                </span>
                <div className="sm-sub-text">
                  <span className="sm-sub-status">
                    {active ? "اشتراک فعال است" : "اشتراک شما منقضی شده"}
                  </span>
                  <span className="sm-sub-date">
                    اعتبار تا {moment(shop.end_date).format("jYYYY/jMM/jDD")}
                  </span>
                </div>
              </div>
              {!active && !isSupport && (
                <button
                  type="button"
                  className="sm-renew-btn"
                  onClick={() => navigate(MY_SITES_PATH)}
                >
                  تمدید اشتراک
                  <Icon className="sm-renew-ic">{CHEVRON_LEFT}</Icon>
                </button>
              )}
            </div>
          </div>
          <div className="sm-meta-item">
            <span className="sm-label">آدرس فروشگاه</span>
            <span className="sm-value">{shop.store_slug}</span>
          </div>
          <div className="sm-meta-item">
            <span className="sm-label">شناسه فروشگاه</span>
            <span className="sm-value sm-mono">#{shop.store_id}</span>
          </div>
        </div>

        <div className="sm-actions">
          {ACTIONS.map((a) => (
            <button
              key={a.id}
              className="sm-act-btn"
              onClick={() => handleAction(a.id)}
            >
              <span className="sm-ic">
                <Icon>{ICONS[a.icon]}</Icon>
              </span>
              {a.label}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
